import React, { useEffect, useState } from 'react';

/** Mobile-only bottom bar that appears once the Buy card (#buy) has scrolled out of view. */
const StickyBuy = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById('buy');
      if (!el) return;
      setShow(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!show) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] border-t-[3px] border-ink bg-ink/95 px-4 pb-[calc(10px+env(safe-area-inset-bottom))] pt-2.5 sm:hidden">
      <a className="btn mx-auto flex w-full max-w-[560px]" href="#buy">
        Buy $BOOP
      </a>
    </div>
  );
};

export default StickyBuy;
